import React from 'react';
import { Row, Col, InputGroup, InputGroupText, Input } from 'reactstrap';

interface UnitDetailsData {
    beds: string;
    baths: string;
    sqft: string;
    dateAvailable: string;
    totalPrice: string;
}

interface UnitDetailsProps {
    unitDetailsData: UnitDetailsData;
}

const UnitDetails: React.FC<UnitDetailsProps> = ({
    unitDetailsData
}) => {
    const {
        beds,
        baths,
        sqft,
        dateAvailable,
        totalPrice
    } = unitDetailsData;

    // Helper function to display value or fallback
    const displayValue = (value: string | undefined | null) => {
        return value && value.trim() !== '' && value !== '0' ? value : 'N/A';
    };

    return (
        <div>
            <Row className="my-3">
                <Col md={4} className="mb-3 mb-md-0">
                    <label className="form-label">Beds</label>
                    <Input type="text" value={displayValue(beds)} readOnly />
                </Col>
                <Col md={4} className="mb-3 mb-md-0">
                    <label className="form-label">Baths</label>
                    <Input type="text" value={displayValue(baths)} readOnly />
                </Col>
                <Col md={4}>
                    <label className="form-label">Size</label>
                    <InputGroup>
                        <Input type="text" value={displayValue(sqft)} readOnly />
                        <InputGroupText>Sq Ft.</InputGroupText>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={6} className="mb-3 mb-md-0">
                    <label className="form-label">Date Available</label>
                    <Input type="text" value={displayValue(dateAvailable)} readOnly />
                </Col>
                <Col md={6}>
                    <label className="form-label">Total Price</label>
                    <InputGroup>
                        <InputGroupText>$</InputGroupText>
                        <Input type="text" value={displayValue(totalPrice)} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </div>
    );
};

export default UnitDetails;